export default __webpack_public_path__ + "static/media/product26_sportsho.5e87f869.webp";